import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { ToastProvider } from "@uhg-abyss/web/ui/Toast";
import { Fragment } from "react";
import { ConfirmApptDetailsCard } from "./ConfirmApptDetailsCard";

export const ConfirmApptDetails = () => {
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);

  return (
    <Fragment>
      <ToastProvider />
      <CommonUI
        FormComponent={ConfirmApptDetailsCard}
        headingText={<span>Almost there!</span>}
        metaTitle="Confirm Appointment Details"
        bodyText={
          <Fragment>
            {isMobile ? (
              <> Please review the details and click 'Schedule appointment' to finish booking.</>
            ) : (
              <>
                {" "}
                Please review the details and click 'Schedule appointment'
                <br />
                to finish booking.
              </>
            )}
          </Fragment>
        }
      />
    </Fragment>
  );
};
